import angular from 'angular';

import NetSalesHistoryPageComponent from './net-sales-history-page-component';
import { NetSalesHistoryPageController } from './net-sales-history-page-controller';

export default angular
  .module('net-sales-history-page', [])
  .controller('NetSalesHistoryPageController', NetSalesHistoryPageController)
  .component('netSalesHistoryPage', NetSalesHistoryPageComponent);



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/net-sales/components/net-sales-history-page/net-sales-history-page-module.js